import { render, staticRenderFns } from "./HighRiskReport.vue?vue&type=template&id=195f81ec&scoped=true&"
import script from "./HighRiskReport.vue?vue&type=script&lang=js&"
export * from "./HighRiskReport.vue?vue&type=script&lang=js&"
import style0 from "./HighRiskReport.vue?vue&type=style&index=0&id=195f81ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195f81ec",
  null
  
)

export default component.exports